import { ScToast } from '@intelipost-js/secure-components';
import { GraphQlClient } from '@intelipost-js/secure-providers';
import { uploadFileToRemoteUrl } from '../../../store/commons';

export default {
  uploadCTeFile({ commit }, params) {
    commit('setLoadingUploadForm', true);

    const { logisticProviderId, ctesFiles } = params;

    const graphParams = {
      logisticProviderId,
      fileName: ctesFiles.filename,
      fileType: ctesFiles.fileType,
      fileSize: ctesFiles.fileSize,
    };

    return GraphQlClient.query(`
      query (
        $logisticProviderId: Int,
        $fileName: String,
        $fileType: String,
        $fileSize: Int
      ) {
        uploadCTeFile(
          logisticProviderId: $logisticProviderId,
          fileName: $fileName,
          fileType: $fileType,
          fileSize: $fileSize
        ) {
          url
        }
      }`, graphParams)
      .then(({ data }) => {
        const { uploadCTeFile } = data || {};
        const uploadURL = uploadCTeFile.url;

        return uploadFileToRemoteUrl(uploadURL, ctesFiles)
          .then((res) => {
            ScToast.success('Upload concluído com sucesso');
            commit('setLoadingUploadForm', false);
            return Promise.resolve(res);
          })
          .catch(() => {
            ScToast.danger('Falha no upload');
            commit('setLoadingUploadForm', false);
          });
      })
      .catch(() => {
        ScToast.danger('Falha no upload');
        commit('setLoadingUploadForm', false);
      });
  },

  getUploadList({ commit }, params) {
    commit('setLoadingUploadList', true);

    return GraphQlClient.query(`
      query($page: Int, $size: Int) {
        listCTeUploads(
          page: $page,
          size: $size
        ) {
          total_size,
          uploads {
            filename
            files_processed
            files_total
            upload_request_date
            upload_start_date
            upload_status
          }
        }
      }`, params)
      .then(({ data }) => {
        const { listCTeUploads } = data || {};
        commit('setUploadList', listCTeUploads.uploads || []);
        commit('setUploadListTotal', listCTeUploads.total_size || 0);
        commit('setLoadingUploadList', false);
      }).catch(() => {
        ScToast.danger('Falha ao buscar os uploads já realizados');
        commit('setLoadingUploadList', false);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-upload/store/actions.js